// Shared mapper: CertificateShare → <PatronageCertificate> props. Used by
// the vault grid thumbnail, the collection detail popup, and the reveal
// ceremony hero so the serial + fields read identically wherever a cert
// renders. `withQuote` includes the creator's hello-text (larger surfaces
// only — the compact grid thumbnail omits it to stay uncluttered).

import {
  isLoadableImageUrl,
  type CertificateShare,
  type PatronageCertificateProps,
} from "@greenhold/components";

import { certSerialFromShareId } from "../../lib/certSerial";

export function certPropsFromShare(
  share: CertificateShare,
  opts: { withQuote?: boolean } = {},
): PatronageCertificateProps {
  const portraitUrl = isLoadableImageUrl(share.snapshot_image_signed_url)
    ? share.snapshot_image_signed_url
    : null;
  return {
    tier: share.tier,
    name: share.snapshot_display_name,
    serial: certSerialFromShareId(share.share_id),
    dossier: share.portfolio_title,
    issued: share.opened_at.slice(0, 10),
    condition: share.condition,
    signed: share.signed,
    portraitUrl,
    quote: opts.withQuote
      ? share.snapshot_hello_text || undefined
      : undefined,
  };
}
